(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("@spiral-toolkit/core", [], factory);
	else if(typeof exports === 'object')
		exports["@spiral-toolkit/core"] = factory();
	else
		root["sf"] = factory();
})(window, function() {
return 